<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-9">
        <h2>Activities Calendar</h2>
        <ol class="breadcrumb">
          <li>
            Home / Management / Activities
          </li>
        </ol>
      </div>
      <div class="col-xs-3 mobile-hide margin-top-10-px">
        <div
             id="create_event"
             class="pull-right">
          <button
                  class="btn btn-primary btn-md"
                  style="line-height: 1.42857143;"
                  @click="openCreateModel()">
            <strong>Create Activity</strong>
          </button>
        </div>
        <div
             id="list-calendar"
             class="pull-right">
          <span v-if="isList">
            <span
                  class="btn btn-primary btn-md"
                  style="line-height: 1.42857143;"
                  @click="changeStyle"><i class="fa fa-list fa-fw" /> <strong>Show in calendar</strong></span>
          </span>
          <span v-else>
            <span
                  class="btn btn-primary btn-md"
                  style="line-height: 1.42857143; margin-left: 60px;"
                  @click="changeStyle"><i class="fa fa-calendar fa-fw" /> <strong>Show in list</strong></span>
          </span>
        </div>
      </div>
      <div
           class="col-xs-3 mobile-show pull-right"
           style="margin-top: 20px; padding-right:0;">
        <div
             id="create_event_mobile"
             class="mobile-show pull-right"
             style="margin-bottom: 10px">
          <button
                  class="btn btn-primary btn-xs"
                  @click="openCreateModel()">
            <strong>Create Activity</strong>
          </button>
        </div>
        <div
             id="list-calendar-mobile"
             class="mobile-show pull-right">
          <span
                :class="{'fa fa-list':isList, 'fa fa-calendar':!isList}"
                class="btn btn-primary btn-xs"
                style="line-height: 1.42857143;"
                @click="changeStyle" />
        </div>
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div :class="{'row animated fadeInDown':true, 'hide':isList}">
        <div
             id="calendar-container"
             class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Activity Calendar</h5>
              <div class="ibox-tools">
                <button
                        class="btn btn-xs btn-primary"
                        @click="downloadCalendar">Download as Image</button>
              </div>
            </div>
            <div class="ibox-content">
              <full-calendar
                             ref="calendar"
                             :config="config"
                             @event-selected="eventClick"
                             @event-created="calendarSelect" />
            </div>
          </div>
        </div>
      </div>
      <div :class="{'row animated fadeInDown':true, 'hide':!isList}">
        <div class="col-xs-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Upcoming Activity</h5>
              <div class="ibox-tools">
                <button
                        class="btn btn-primary btn-xs"
                        @click="downloadPDF">Download Upcoming Activities as PDF</button>
                <button
                        class="btn btn-primary btn-xs"
                        @click="markNextWeekVisiable">Mark Next Week's Activities as Visible</button>
              </div>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Activity Title</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Location</th>
                      <th>Details</th>
                      <th>Visibility</th>
                      <th>Forbidden Time Before Start (minutes)</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                        v-for="event in futureEvents"
                        :key="event.id"
                        :id="`event-${event.id}`">
                      <td class="project-title">
                        <router-link :to="{ name: 'event-info', params: { id: event.id }}">{{ event.name }}</router-link>
                      </td>
                      <td class="project-start-time">
                        <p>{{ event.start_time | moment("YYYY-MM-DD HH:mm") }}</p>
                      </td>
                      <td class="project-end-time">
                        <p>{{ event.end_time | moment( "YYYY-MM-DD HH:mm") }}</p>
                      </td>
                      <td class="project-location">
                        <p>{{ event.location }}</p>
                      </td>
                      <td class="project-completion">
                        <small>Registration: {{ event.registered_count }} / {{ event.total_seats }}</small>
                        <div class="progress progress-mini">
                          <div
                               :style="{width: event.registered_count / event.total_seats * 100 + '%'}"
                               class="progress-bar" />
                        </div>
                      </td>
                      <td class="project-visibility">
                        <i
                           :class="{
                            'text-navy fa-check': event.visibility,
                            'fa-times': !event.visibility
                          }"
                           class="fa" />
                      </td>
                      <td class="project-location">
                        <p>{{ event.forbid_minutes }}</p>
                      </td>
                      <td class="project-actions pull-right">
                        <router-link
                                     :to="{ name: 'event-info', params: { id: event.id }}"
                                     class="btn btn-white btn-sm">
                          <i class="fa fa-folder fa-fw" /> View & Edit </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div :class="{'row animated fadeInDown':true, 'hide':!isList}">
        <div class="col-xs-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>This Week Activity</h5>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Activity Title</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Location</th>
                      <th>Details</th>
                      <th>Forbidden Time Before Start (minutes)</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                        v-for="event in thisWeekEvents"
                        :key="event.id"
                        :id="`event-${event.id}`">
                      <td class="project-title">
                        <router-link :to="{ name: 'event-info', params: { id: event.id }}">{{ event.name }}</router-link>
                      </td>
                      <td class="project-start-time">
                        <p>{{ event.start_time | moment("YYYY-MM-DD HH:mm") }}</p>
                      </td>
                      <td class="project-end-time">
                        <p>{{ event.end_time | moment( "YYYY-MM-DD HH:mm") }}</p>
                      </td>
                      <td class="project-location">
                        <p>{{ event.location }}</p>
                      </td>
                      <td class="project-completion">
                        <small>Registration: {{ event.registered_count }} / {{ event.total_seats }}</small>
                        <div class="progress progress-mini">
                          <div
                               :style="{width: event.registered_count / event.total_seats * 100 + '%'}"
                               class="progress-bar" />
                        </div>
                      </td>
                      <td class="project-location">
                        <p>{{ event.forbid_minutes }}</p>
                      </td>
                      <td class="project-actions pull-right">
                        <router-link
                                     :to="{ name: 'event-info', params: { id: event.id }}"
                                     class="btn btn-white btn-sm">
                          <i class="fa fa-folder fa-fw" /> View & Edit </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div :class="{'row animated fadeInDown':true, 'hide':!isList}">
        <div class="col-xs-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Past Activity</h5>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Activity Title</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Location</th>
                      <th>Details</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                        v-for="event in pastEvents"
                        :key="event.id"
                        :id="`event-${event.id}`">
                      <td class="project-title">
                        <router-link :to="{ name: 'event-info', params: { id: event.id }}">{{ event.name }}</router-link>
                      </td>
                      <td class="project-start-time">
                        <p>{{ event.start_time | moment("YYYY-MM-DD HH:mm") }}</p>
                      </td>
                      <td class="project-end-time">
                        <p>{{ event.end_time | moment( "YYYY-MM-DD HH:mm") }}</p>
                      </td>
                      <td class="project-location">
                        <p>{{ event.location }}</p>
                      </td>
                      <td class="project-completion">
                        <small>Registration: {{ event.registered_count }} / {{ event.total_seats }}</small>
                        <div class="progress progress-mini">
                          <div
                               :style="{width: event.registered_count / event.total_seats * 100 + '%'}"
                               class="progress-bar" />
                        </div>
                      </td>
                      <td class="project-actions pull-right">
                        <router-link
                                     :to="{ name: 'event-info', params: { id: event.id }}"
                                     class="btn btn-white btn-sm"><i class="fa fa-folder" /> View & Edit </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <div
         id="eventCreationModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="eventCreationLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create Activity</h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form role="form">
              <div class="form-group">
                <label>Choose an Activity Description</label>
                <select
                        id=""
                        v-model="chosenTemplate"
                        name=""
                        class="form-control m-b">
                  <option value="-1">Do not use any</option>
                  <option
                          v-for="template in templates"
                          :key="template.id"
                          :value="template.id - 1">{{ template.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Name</label>
                <input
                       v-model.trim="newEvent.name"
                       type="name"
                       placeholder="Enter activity name"
                       class="form-control m-b">
              </div>
              <div class="form-group">
                <label>Description</label>
                <input
                       v-model.trim="newEvent.description"
                       type="description"
                       placeholder="Enter activity description"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Time</label>
                <div class="input-daterange input-group">
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-time" />
                  </span>
                  <input
                         id="timespan"
                         type="text"
                         class="input-sm form-control"
                         name="timespan"
                         required>
                </div>
              </div>
              <div class="form-group">
                <label>Weekly Unique ID (Forbid user from enrolling activities in the same value)</label>
                <div class="input-daterange input-group">
                  <input
                         v-model.trim.number="newEvent.weeklyUniqueID"
                         type="text"
                         class="input-sm form-control"
                         name="weekly_unique_num"
                         required>
                </div>
              </div>
              <div class="form-group">
                <label>Forbidden Time Before Start (in Minute)</label>
                <input
                       v-model.trim.number="newEvent.forbid_minutes"
                       type="number"
                       placeholder="Enter the time"
                       class="input-sm form-control"
                       name="forbid_minutes">
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Available Seats</label>
                    <input
                           v-model.trim.number="newEvent.availableSeats"
                           type="number"
                           min="0"
                           step="1"
                           placeholder="Enter the number of seats available"
                           class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Location</label>
                    <input
                           v-model.trim="newEvent.location"
                           type="text"
                           placeholder="Enter the location"
                           class="form-control">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Color</label>
                    <span
                          :style="{background: newEvent.color}"
                          style="padding: 7px;  text-align: center; margin-top: 20px; display: inline-block;"
                          class="m-l-md" />
                    <div class="btn-group m-l-md">
                      <button
                              data-toggle="dropdown"
                              class="btn btn-default dropdown-toggle"> {{ newEvent.color }}</button>
                      <ul class="dropdown-menu">
                        <chrome-picker
                                       id="colorpicker"
                                       :value="newEvent.color"
                                       class="m-t-xs"
                                       @input="updateColor" />
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div>
                    <label> <input
                             v-model="newEvent.visibility"
                             type="checkbox"> Visibility </label>
                  </div>
                </div>
              </div>

            </form>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This event cannot be created: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal">Cancel</button>
            <vue-ladda
                       :loading="inCreatingActivity"
                       button-class="btn btn-md btn-primary"
                       data-style="expand-right"
                       @click="createEvent()">
              Create
            </vue-ladda>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript" src="<%= BASE_URL %>js/daterangepicker.js"></script>

<script>
// @ is an alias to /src
import { FullCalendar } from "vue-full-calendar";
import { QRCode } from "@/utils/qrcode.js";
import "@/assets/inspinia/font-awesome/css/font-awesome.css";
import Datepicker from "vuejs-datepicker";
import html2canvas from "html2canvas";
import { Chrome } from "vue-color";
import VueLadda from "@/components/vue-ladda.vue";
import JSPDF from "jspdf";
import kjua from 'kjua';

const that = this;

export default {
  name: "home-teacher",
  components: {
    FullCalendar,
    Datepicker,
    "chrome-picker": Chrome,
    "vue-ladda": VueLadda
  },
  data () {
    return {
      isList: true,
      events: [],
      newEvent: {
        color: "#1AB394"
      },
      templates: [],
      config: {
        weekends: false,
        editable: false,
        selectable: true,
        businessHours: {
          // days of week. an array of zero-based day of week integers (0=Sunday)
          dow: [1, 2, 3, 4, 5], // Monday - Thursday
          start: "9:00", // a start time (10am in this example)
          end: "18:00" // an end time (6pm in this example)
        },
        minTime: "9:00:00",
        maxTime: "18:30:00",
        slotDuration: "00:15:00",
        slotLabelInterval: "00:30:00",
        height: "parent",
        timezone: "local"
      },
      eventNewStartTime: 0,
      eventNewEndTime: 0,
      chosenTemplate: -1,
      errorMessage: "Unexpected error",
      errorShow: false,
      inCreatingActivity: false
    };
  },
  computed: {
    firstDayoftheWeek () {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      var day = d.getDay(),
        diff = d.getDate() - day; // adjust when day is sunday
      return new Date(d.setDate(diff)).getTime() / 1000;
    },
    orderedEvents () {
      let newEvents = JSON.parse(JSON.stringify(this.events));
      newEvents.sort(function (a, b) {
        return a.start_time - b.start_time;
      });
      return newEvents;
    },
    thisWeekEvents () {
      const f = this.firstDayoftheWeek;
      const l = f + 7 * 24 * 60 * 60;
      return this.orderedEvents.filter(function (a) {
        return a.start_time > f && a.start_time < l;
      });
    },
    futureEvents () {
      const f = Date.now() / 1000;
      return this.orderedEvents.filter(function (a) {
        return a.start_time >= f;
      });
    },
    pastEvents () {
      const f = Date.now() / 1000;
      return this.orderedEvents.filter(function (a) {
        return a.start_time < f;
      });
    }
  },
  watch: {
    chosenTemplate: function (newChosen, oldChosen) {
      if (newChosen !== -1) {
        const newValues = Object.assign({}, this.templates[newChosen]);
        this.newEvent.name = newValues.name;
        this.newEvent.description = newValues.description;
        this.newEvent.availableSeats = newValues.seats_available;
        this.newEvent.location = newValues.location;
        this.newEvent.weeklyUniqueID = newChosen;
        this.newEvent.forbid_minutes = newValues.forbid_minutes
        if (newChosen != -1) {
          this.newEvent.color = newValues.color;
        } else {
          this.newEvent.color = "#1ab394";
        }
        const duration = moment.duration(Number(newValues.duration), "hours");

        $("#timespan")
          .data("daterangepicker")
          .setEndDate(
            moment($("#timespan").data("daterangepicker").startDate).add(
              duration
            )
          );
        this.newEvent.startTime = $("#timespan")
          .data("daterangepicker")
          .startDate.unix();
        this.newEvent.endTime = $("#timespan")
          .data("daterangepicker")
          .endDate.unix();
      }
    }
  },
  methods: {
    updateColor (value) {
      this.newEvent.color = value["hex"];
    },
    checkEventValidation (event) {
      // check empty
      if (!event.name) {
        return "Please input an activity name!";
      }
      if (!event.description) {
        return "Please input an activity description!";
      }
      if (!event.location) {
        return "Please input an activity location!";
      }
      // check validation
      //check times
      const nowTime = Date.now() / 1000;
      if (event.startTime < nowTime || event.endTime < nowTime) {
        return "Please select a future time!";
      }
      if (event.startTime >= event.endTime) {
        return "End time should be later than start time!";
      }
      if (moment(event.startTime * 1000).hour() < 9) {
        return "Start time should not be earlier than 9am!";
      }
      if (
        moment(event.endTime * 1000).hour() >= 18 &&
        moment(event.endTime * 1000).minute() >= 1
      ) {
        return "End time should not be later than 18am!";
      }
      //check seats
      var reg = /[^0-9]/;
      if (reg.test(event.availableSeats) || event.availableSeats <= 0) {
        return "Please input a correct seats number!";
      }
      return 0;
    },
    createEvent () {
      // start loading
      this.inCreatingActivity = true;
      const that = this;
      that.errorShow = false;
      that.errorMessage = that.checkEventValidation(that.newEvent);
      if (that.errorMessage != 0) {
        setTimeout(function () {
          that.errorShow = true;
        }, 500);
        this.inCreatingActivity = false;
        return;
      }
      console.log("Creating event", {
        name: this.newEvent.name,
        description: this.newEvent.description,
        start_time: this.newEvent.startTime,
        end_time: this.newEvent.endTime,
        total_seats: this.newEvent.availableSeats,
        location: this.newEvent.location,
        color: this.newEvent.color,
        weekly_unique_id: this.newEvent.weeklyUniqueID,
        visibility: this.newEvent.visibility,
        forbid_minutes: this.newEvent.forbid_minutes
      });
      this.request
        .post("event/", {
          name: this.newEvent.name,
          description: this.newEvent.description,
          start_time: this.newEvent.startTime,
          end_time: this.newEvent.endTime,
          total_seats: this.newEvent.availableSeats,
          location: this.newEvent.location,
          color: this.newEvent.color,
          weekly_unique_id: this.newEvent.weeklyUniqueID,
          visibility: this.newEvent.visibility,
          forbid_minutes: this.newEvent.forbid_minutes
        })
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          toastr.success("You have successfully create an activity!");
          that.$refs.calendar.fireMethod("removeEventSources");

          that.newEvent.name = ""
          that.newEvent.description = ""
          that.newEvent.startTime = 0
          that.newEvent.endTime = 0
          that.newEvent.availableSeats = 0
          that.newEvent.location = ""
          that.newEvent.color = ""
          that.newEvent.weeklyUniqueID = 0
          that.newEvent.visibility = false
          that.newEvent.forbid_minutes = 0
          that.chosenTemplate = -1;

          that.fetchEvents().then(() => {
            $("#eventCreationBtn").button("reset");
            $("#eventCreationModal").modal("hide");
            console.log("event creation success");
          });
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#eventCreationBtn").button("reset");
        })
        .finally(() => {
          this.inCreatingActivity = false;
        });
    },
    eventClick (event) {
      this.$router.push({ name: "event-info", params: { id: event.id } });
    },
    calendarSelect (event) {
      console.log(Date.now(), event.start.valueOf());
      if (!(Date.now() < event.start.valueOf())) {
        console.log("Activity could not be passed.");

        this.$refs.calendar.fireMethod("unselect");
        return false;
      }
      this.openCreateModel();
      $("#timespan")
        .data("daterangepicker")
        .setStartDate(event.start);
      $("#timespan")
        .data("daterangepicker")
        .setEndDate(event.end);

    },
    changeStyle () {
      this.isList = !this.isList;
      const that = this;
      window.setTimeout(() => {
        that.$refs.calendar.fireMethod("render");
        that.$refs.calendar.fireMethod("rerenderEvents");
      }); // force to re-render}
    },
    fetchEvents () {
      const that = this;
      return new Promise((resolve, reject) => {
        this.$emit("showLoading");
        window.request
          .get("event")
          .then(response => {
            if (response.data.events) {
              that.events = response.data.events;
              let events = [];
              response.data.events.forEach(event => {
                let s, e;
                s = new Date();
                s.setTime(event.start_time * 1000);
                e = new Date();
                e.setTime(event.end_time * 1000);
                events.push({
                  id: event.id,
                  title: event.name,
                  start: s.toISOStringZoned(),
                  end: e.toISOStringZoned(),
                  backgroundColor: event.color,
                  borderColor: "#ddd",
                  className: event.visibility ? 'visible-event' : 'invisible-event'
                });
              });
              let eventSources = {
                events
              };
              that.$refs.calendar && that.$refs.calendar.fireMethod("removeEventSources");
              that.$refs.calendar &&
                that.$refs.calendar.fireMethod("addEventSource", eventSources);
              console.log("Loaded events:", eventSources);
              console.log(that.$refs.calendar.fireMethod('getEventSources'));
              const today = new Date();
              if (![0, 6].includes(today.getDay())) {
                that.$refs.calendar &&
                  that.$refs.calendar.fireMethod(
                    "gotoDate",
                    moment()
                      .add(1, "weeks")
                      .isoWeekday(1)
                  );
              }
            }
          })
          .finally(() => {
            that.$emit("hideLoading");
            resolve();
          });
      });
    },
    fetchEventTemplates () {
      const that = this;
      window.request
        .get("template")
        .then(response => {
          if (response.data.templates) {
            that.templates = response.data.templates;
          }
        })
        .finally(() => that.$emit("hideLoading"));
    },
    downloadCalendar () {
      const that = this;
      that.$refs.calendar.fireMethod("option", "height", "auto");
      that.$refs.calendar.fireMethod("option", "slotDuration", "00:30:00");
      that.$refs.calendar.fireMethod("option", "slotLabelInterval", "01:00:00");

      html2canvas(document.querySelector("#calendar")).then(canvas => {
        var imgData = canvas.toDataURL("image/jpeg");
        that.download(imgData, "sall.jpg");
        that.$refs.calendar.fireMethod(
          "option",
          "height",
          that.config.height || "parent"
        );
        that.$refs.calendar.fireMethod(
          "option",
          "slotDuration",
          that.config.slotDuration || "00:15:00"
        );
        that.$refs.calendar.fireMethod(
          "option",
          "slotLabelInterval",
          that.config.slotLabelInterval || "00:30:00"
        );
      });
    },
    downloadPDF () {
      let PDF = new JSPDF("", "pt", "a4"); // 595.4 × 842 points

      PDF.setLineWidth(2)
      const events = {}
      const weeklyUniqueIDs = new Set()
      this.futureEvents.forEach((event) => {
        if (event.visibility === true) {
          events.hasOwnProperty(event.weekly_unique_id) ? events[event.weekly_unique_id].push(event) : events[event.weekly_unique_id] = [event]
          weeklyUniqueIDs.add(event.weekly_unique_id)
        }
      })

      PDF.text(`PDF generated at ${moment().format("YYYY-MM-DD HH:mm")}`, 52, 52)

      weeklyUniqueIDs.forEach((wuid) => {

        const eventsToProceed = events[wuid]
        const length = eventsToProceed.length

        const pages = parseInt(length / 4) + (length % 4 ? 1 : 0)
        for (let index = 0; index < pages; index++) {
          PDF.addPage()
          let qrcodeContainer = document.createElement('canvas')
          const elements = eventsToProceed.slice(index * 4, (index + 1) * 4)
          console.log('Generating PDF for elements:', elements)
          PDF.line(0, 420, 595.4, 420)
          PDF.line(296.7, 0, 296.7, 842)

          PDF.setFontSize(18)
          PDF.text(elements[0].name, 52, 52, {
            maxWidth: 210
          })

          PDF.setFontSize(14)
          PDF.text('Start Time: ' + moment(elements[0].start_time * 1000).format("ddd, MMM Do, HH:mm"), 52, 96, {
            maxWidth: 210
          })
          PDF.text('End Time: ' + moment(elements[0].end_time * 1000).format("ddd, MMM Do, HH:mm"), 52, 120, {
            maxWidth: 210
          })
          PDF.text(elements[0].location, 52, 148, {
            maxWidth: 210
          })

          PDF.addImage(kjua({
            text: `https://weixiao.cuhk.edu.cn/qrcode/sall?id=${
              elements[0].id
              }&token=${elements[0].signin_token}`,
            render: 'canvas',
            size: 210
          }), '', 52, 176, 210, 210)

          if (elements.length > 1) {
            PDF.setFontSize(18)
            PDF.text(elements[1].name, 348, 52, {
              maxWidth: 210
            })

            PDF.setFontSize(14)
            PDF.text('Start Time: ' + moment(elements[1].start_time * 1000).format("ddd, MMM Do, HH:mm"), 348, 96, {
              maxWidth: 210
            })
            PDF.text('End Time: ' + moment(elements[1].end_time * 1000).format("ddd, MMM Do, HH:mm"), 348, 120, {
              maxWidth: 210
            })
            PDF.text(elements[1].location, 348, 148, {
              maxWidth: 210
            })

            PDF.addImage(kjua({
              text: `https://weixiao.cuhk.edu.cn/qrcode/sall?id=${
                elements[1].id
                }&token=${elements[1].signin_token}`,
              render: 'canvas',
              size: 210
            }), '', 348, 176, 210, 210)
          }

          if (elements.length > 2) {
            PDF.setFontSize(18)
            PDF.text(elements[2].name, 52, 472, {
              maxWidth: 210
            })

            PDF.setFontSize(14)
            PDF.text('Start Time: ' + moment(elements[2].start_time * 1000).format("ddd, MMM Do, HH:mm"), 52, 516, {
              maxWidth: 210
            })
            PDF.text('End Time: ' + moment(elements[2].end_time * 1000).format("ddd, MMM Do, HH:mm"), 52, 540, {
              maxWidth: 210
            })
            PDF.text(elements[2].location, 52, 568, {
              maxWidth: 210
            })

            PDF.addImage(kjua({
              text: `https://weixiao.cuhk.edu.cn/qrcode/sall?id=${
                elements[2].id
                }&token=${elements[2].signin_token}`,
              render: 'canvas',
              size: 210
            }), '', 52, 596, 210, 210)
          }

          if (elements.length > 3) {
            PDF.setFontSize(18)
            PDF.text(elements[3].name, 348, 472, {
              maxWidth: 210
            })

            PDF.setFontSize(14)
            PDF.text('Start Time: ' + moment(elements[3].start_time * 1000).format("ddd, MMM Do, HH:mm"), 348, 516, {
              maxWidth: 210
            })
            PDF.text('End Time: ' + moment(elements[3].end_time * 1000).format("ddd, MMM Do, HH:mm"), 348, 540, {
              maxWidth: 210
            })
            PDF.text(elements[3].location, 348, 568, {
              maxWidth: 210
            })

            PDF.addImage(kjua({
              text: `https://weixiao.cuhk.edu.cn/qrcode/sall?id=${
                elements[3].id
                }&token=${elements[3].signin_token}`,
              render: 'canvas',
              size: 210
            }), '', 348, 596, 210, 210)
          }
        }
      })
      PDF.save('signin-page.pdf')
    },
    download (strData, strFileName) {
      var D = document,
        A = arguments,
        a = D.createElement("a"),
        d = A[0],
        n = A[1],
        t = A[2] || "text/plain";

      //build download link:
      a.href = strData;

      if (window.MSBlobBuilder) {
        var bb = new MSBlobBuilder();
        bb.append(strData);
        return navigator.msSaveBlob(bb, strFileName);
      } /* end if(window.MSBlobBuilder) */

      if ("download" in a) {
        a.setAttribute("download", n);
        a.innerHTML = "downloading...";
        D.body.appendChild(a);
        setTimeout(function () {
          var e = D.createEvent("MouseEvents");
          e.initMouseEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
          D.body.removeChild(a);
        }, 66);
        return true;
      } /* end if('download' in a) */

      //do iframe dataURL download:
      var f = D.createElement("iframe");
      D.body.appendChild(f);
      f.src =
        "data:" +
        (A[2] ? A[2] : "application/octet-stream") +
        (window.btoa ? ";base64" : "") +
        "," +
        (window.btoa ? window.btoa : escape)(strData);
      setTimeout(function () {
        D.body.removeChild(f);
      }, 333);
      return true;
    },
    openCreateModel () {
      const that = this;
      $("#timespan").daterangepicker({
        showDropdowns: true,
        timePicker: true,
        timePicker24Hour: true,
        autoApply: true,
        locale: {
          format: "M/DD hh:mm A"
        },
        minDate: moment(),
        startDate: event.start,
        endDate: event.end
      },
        function (start, end, label) {
          that.newEvent.startTime = start.unix();
          that.newEvent.endTime = end.unix();
        }
      )
      this.errorShow = false
      this.errorMessage = ""

      $("#eventCreationModal").modal("show");
      this.$forceUpdate()
    },
    markNextWeekVisiable () {
      this.$emit("showLoading");
      this.request
        .post("event/mark-next-week-visible", {

        })
        .then(response => {
          this.fetchEvents()
        })
        .catch(error => {
          console.log(error)
          toastr.error(error.response.data.message || error.response.data.error);
        })
        .finally(() => {
          this.$emit("hideLoading");
        });
    }
  },
  mounted () {
    const moment = window.moment;
    const that = this;

    this.fetchEvents();
    this.fetchEventTemplates();

    $('.i-checks').iCheck({
      checkboxClass: 'icheckbox_square-green',
      radioClass: 'iradio_square-green',
    }).on('ifChecked ifUnchecked', function () {
      $(this)[0].dispatchEvent(new Event("change"));
    });
  }
};
</script>

<style>
#list-calendar span {
  cursor: pointer;
}

#list-calendar {
  padding: 2% 0 2% 0;
  /* font-size: 18px; */
}

.invisible-event {
  background: radial-gradient(black 15%, transparent 16%) 0 0,
    radial-gradient(black 15%, transparent 16%) 8px 8px,
    radial-gradient(rgba(255, 255, 255, 0.1) 15%, transparent 20%) 0 1px,
    radial-gradient(rgba(255, 255, 255, 0.1) 15%, transparent 20%) 8px 9px;
  background-color: #282828;
  background-size: 16px 16px;
}
</style>

